import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// 受保护的路由组件
const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  // 如果正在加载认证状态，显示加载中
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>正在验证身份...</p>
      </div>
    );
  }

  // 如果未认证，重定向到登录页面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 如果已认证，渲染子路由
  return <Outlet />;
};

export default ProtectedRoute; 